"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _styles = require("@material-ui/core/styles");
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
var _core = require("@material-ui/core");
var _reactUse = require("react-use");
var _gatsbyPluginImage = require("gatsby-plugin-image");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
    palette = _ref.palette,
    shape = _ref.shape;
  return {
    root: {
      height: "100%",
      background: palette.common.white,
      "& .gatsby-image-wrapper": {
        height: "100%",
        width: "100%"
      },
      "& .slick-list": {
        height: "100%"
      },
      "& .slick-track": {
        height: "100%"
      },
      "& .slick-slide > div": {
        display: "flex",
        height: "100%"
      },
      "& .slick-prev": {
        left: spacing(1),
        zIndex: 1
      },
      "& .slick-next": {
        right: spacing(1),
        zIndex: 1
      },
      "& .slick-dots": {
        top: 0,
        bottom: "auto",
        display: "flex!important",
        justifyContent: "center",
        paddingLeft: spacing(2),
        paddingRight: spacing(2),
        "& li": {
          margin: 0,
          width: "30px",
          "& button::before": {
            fontSize: spacing(1.2)
          },
          "&.slick-active": {
            "& button::before": {
              color: palette.common.white
            }
          }
        }
      }
    },
    imageWrap: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "bottom"
    },
    loadingContainer: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  };
});
var InImage = function InImage(props) {
  var _props$image, _props$image2, _props$image3;
  var gi = (props === null || props === void 0 || (_props$image = props.image) === null || _props$image === void 0 || (_props$image = _props$image.Image) === null || _props$image === void 0 || (_props$image = _props$image.localFile) === null || _props$image === void 0 || (_props$image = _props$image.childImageSharp) === null || _props$image === void 0 ? void 0 : _props$image.gatsbyImageData) || (0, _gatsbyPluginImage.getImage)((props === null || props === void 0 || (_props$image2 = props.image) === null || _props$image2 === void 0 ? void 0 : _props$image2.imageFile) || (props === null || props === void 0 || (_props$image3 = props.image) === null || _props$image3 === void 0 ? void 0 : _props$image3.Image));
  if (props.useNoneGatsbyImage || !gi || gi === "") {
    return /*#__PURE__*/_react["default"].createElement("img", {
      className: props.className,
      alt: "Boat carousel image",
      src: props.image.path
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_gatsbyPluginImage.GatsbyImage, {
    image: gi,
    loading: "lazy",
    alt: "Boat carousel image"
  });
};
function Carousel(_ref2) {
  var media = _ref2.media,
    className = _ref2.className,
    useNoneGatsbyImage = _ref2.useNoneGatsbyImage,
    imageLoading = _ref2.imageLoading;
  var _useStyles = useStyles(),
    root = _useStyles.root,
    imageWrap = _useStyles.imageWrap,
    loadingContainer = _useStyles.loadingContainer;
  var slider = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  (0, _reactUse.useUpdateEffect)(function () {
    // we are forcing a loading state which resets the slider component
    setLoading(true);
    setTimeout(function () {
      setLoading(false);
    }, 400);
  }, [media]);
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_core.Box, {
      className: loadingContainer
    }, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, null));
  }
  return /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], {
    ref: slider,
    className: "".concat(className, " ").concat(root),
    dots: true
  }, media.map(function (m, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(InImage, {
      className: imageWrap,
      image: m,
      useNoneGatsbyImage: useNoneGatsbyImage,
      imageLoading: index === 0 ? imageLoading : "lazy",
      index: index
    }));
  }));
}
var _default = exports["default"] = Carousel;